import React, { useCallback, useMemo } from 'react';
import { LotI, NFTI } from '@tacans/shared-marketplace-layer';
import { Button } from 'src/ui/common/atoms/button';
import { useTranslation } from 'next-i18next';
import { useRenderBidsSidebar } from 'src/features/common/collectible/hooks/use-render-bids-sidebar';
import { useGetActiveTokenTransaction } from 'src/features/common/collectible/hooks/useGetActiveTokenTransaction.hook';
import { ButtonProps } from 'src/ui/common/atoms/button/button.types';

interface Props {
    nft: NFTI;
    lot: LotI;
    small?: boolean;
    variant?: ButtonProps['variant'];
}

export const ViewBidsAction: React.VFC<Props> = ({ small, lot, nft, variant='white' }) => {
    const { t } = useTranslation(['actions']);
    const renderBidsSidebar = useRenderBidsSidebar();
    const activeTransactions = useGetActiveTokenTransaction();

    const locale = useMemo(() => ({
        viewBids: t('trade.viewBids', { ns: 'actions' }),
    }), [t]);

    const openBidsSideBar = useCallback(() => {
        renderBidsSidebar(nft, lot);
    }, [lot, nft, renderBidsSidebar]);

    return (
        <Button
            onClick={openBidsSideBar}
            disabled={!!activeTransactions.length}
            data-test-id='view-bids-btn'
            variant={variant}
            size={small ? 'sm' : 'lg'}
        >
            {locale.viewBids}
        </Button>
    );
};
